import React, { useEffect, useState } from 'react';
import service from 'services/restaurantService';
import styled from 'styled-components';
import Aux from 'hoc/ReactAux/ReactAux';
import Logo from 'components/Logo/Logo';
import { CustomHeader } from './styles';
import defaultBg from '../../../assets/images/header.jpg';

const Header = props => {
  const [urlImage, setUrlImage] = useState(defaultBg);

  useEffect(() => {
    props.restaurantSelected &&
      fetchRestaurantCover(props.restaurantSelected.id).then(value => {
        value.url ? setUrlImage(value.url) : setUrlImage(defaultBg);
      });
  }, [props.restaurantSelected]);

  function mountHeader(title, showRestaurantOption) {
    let CartComponent = styled.a`
                &:after {
                  content: '${props.quantityProductsSelected}';
                  background:#ff5007;
                  width:17px;
                  height:17px;
                  display:-webkit-inline-box;
                  display:-ms-inline-flexbox;
                  display:inline-flex;
                  -webkit-box-align:center;
                  -ms-flex-align:center;
                  align-items:center;
                  -webkit-box-pack:center;
                  -ms-flex-pack:center;
                  justify-content:center;
                  color:white;
                  border-radius:100%;
                  padding:0.1px;
                  font-size:10.2px;
                  text-align:center;
                  position:absolute;
                  padding:0.7px;
                  margin-top:-9px;
                  margin-left:-6px
                }
              `;

    let classesHeader = 'office-hours';

    if (!!props.restaurantSelected && props.restaurantSelected.isOpen) {
      classesHeader = 'office-hours open';
    } else if (
      !!props.restaurantSelected &&
      !!!props.restaurantSelected.isOpen
    ) {
      classesHeader = 'office-hours closed';
    }

    let changeHour = hour => {
      let [hours, minutes] = hour.split(':');
      let formatedHours = null;

      if (hours >= 0 && hours <= 12) {
        formatedHours = hours + ':' + minutes + ' AM';
      } else if (hours > 12) {
        formatedHours = hours - 12 + ':' + minutes + ' PM';
      }

      return formatedHours;
    };

    let contentHeader = (
      <Aux>
        <h1>
          {props.restaurantSelected ? props.restaurantSelected.name : title}
        </h1>
        <div className="infos" aria-label="Restaurant infos">
          <div className="left">
            {props.restaurantSelected && props.restaurantSelected.openingHour && (
              <span className={classesHeader}>
                {props.restaurantSelected && props.restaurantSelected.isOpen
                  ? 'OPEN ' +
                    changeHour(props.restaurantSelected.openingHour.openHour) +
                    ' - ' +
                    changeHour(props.restaurantSelected.openingHour.closeHour)
                  : props.restaurantSelected
                  ? 'CLOSED ' +
                    changeHour(props.restaurantSelected.openingHour.openHour) +
                    ' - ' +
                    changeHour(props.restaurantSelected.openingHour.closeHour)
                  : ''}{' '}
                {props.restaurantSelected &&
                props.restaurantSelected.forCollection === 'Y'
                  ? 'Address : ' +
                    props.restaurantSelected.address.substring(0, 50)
                  : ''}
              </span>
            )}
          </div>
          <div
            className="right"
            aria-label="Delivery and collection infos"
            tabIndex={2}
          >
            {props.showCollectionOption &&
              showRestaurantOption &&
              props.restaurantsOptions.map(options => (
                <Aux key={options.id}>
                  <input
                    onChange={() => props.toggleRestaurantOptions(options.id)}
                    type="radio"
                    name="restaurantOptions"
                    id={options.type}
                    checked={options.active}
                    aria-checked={options.active}
                  />
                  <label htmlFor={options.type}>{options.type}</label>
                </Aux>
              ))}
            <CartComponent className="cart-bar">
              <i
                aria-label="cart icon"
                ref={btnCart => btnCart}
                onClick={() => props.toggleCart()}
                className="sprite white-cart25"
                aria-haspopup="true"
              ></i>
            </CartComponent>
          </div>
        </div>
      </Aux>
    );
    return contentHeader;
  }

  function fetchRestaurantCover(id) {
    var response = service.fetchingRestaurantCover(id);
    return response;
  }

  let itemActive = props.itemsSideBarMenu.find(item => {
    return item.active === true;
  });
  let contentHeader = null;
  switch (itemActive.index) {
    case 1:
    case 2:
      contentHeader = mountHeader(props.titleHeader, true);
      break;
    case 3:
    case 4:
    case 5:
      contentHeader = mountHeader(props.titleHeader, false);
      break;
    case 6:
    case 7:
    case 8:
      contentHeader = (
        <Aux>
          <h1>{props.titleHeader}</h1>
          <div className="infos"></div>
        </Aux>
      );
      break;
    default:
      break;
  }

  return (
    <div>
      <div
        className="top-header"
        aria-label={`Banner ${
          props.restaurantSelected
            ? props.restaurantSelected.name
            : 'Popular Dishes'
        }`}
      >
        <header className="menu-mobile">
          <Logo goToMenu={props.goToDefaultMenu} />
          <a
            id="menu_toggle"
            className={props.showMenuMobile ? 'menu open' : 'menu'}
            onClick={() => props.toggleMenuMobile()}
            alt="Menu bar"
          >
            <svg
              className="svg-inline--fa fa-bars fa-w-14"
              aria-hidden="true"
              data-prefix="fas"
              data-icon="bars"
              role="img"
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 448 512"
              data-fa-i2svg=""
            >
              <path
                fill="currentColor"
                d="M16 132h416c8.837 0 16-7.163 16-16V76c0-8.837-7.163-16-16-16H16C7.163 60 0 67.163 0 76v40c0 8.837 7.163 16 16 16zm0 160h416c8.837 0 16-7.163 16-16v-40c0-8.837-7.163-16-16-16H16c-8.837 0-16 7.163-16 16v40c0 8.837 7.163 16 16 16zm0 160h416c8.837 0 16-7.163 16-16v-40c0-8.837-7.163-16-16-16H16c-8.837 0-16 7.163-16 16v40c0 8.837 7.163 16 16 16z"
              />
            </svg>
          </a>
        </header>
        <CustomHeader
          className="header-restaurant"
          style={{ backgroundImage: `url(${urlImage})` }}
        >
          {contentHeader}
        </CustomHeader>
      </div>
    </div>
  );
};

export default Header;



// WEBPACK FOOTER //
// ./src/containers/Menu/Header/index.js